<template>
  <page-outline :title="changePassword_title">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <b-row class="ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold">
        <b-col sm="5">
          <form-read-group-label-input
            :inputLabel="$t('common.idtfr')" :inputValue="login">
          </form-read-group-label-input>
        </b-col>
        <b-col v-if="!connectToGoogle" sm="5">
          <form-write-group-label-input v-model="originalPassword" isMandatory
            :inputLabel="$t('common.orig_pwd')"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row class="ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold">
        <b-col v-if="connectToGoogle" sm="5">
          <form-write-group-label-input v-model="newPassword" isMandatory
            :inputLabel="$t('common.pwd')"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
        <b-col v-if="!connectToGoogle" sm="5">
          <form-write-group-label-input v-model="newPassword" isMandatory
            :inputLabel="$t('common.new_pwd')"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="5">
          <form-write-group-label-input v-model="confirmNewPassword" isMandatory
            :inputLabel="$t('common.conf_pwd')"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row v-if="connectToGoogle">
        <div class="text-right col-sm-12 small font-italic">{{ $t('profilesPage.ggl_check_pwd') }}</div>
      </b-row>
      <b-row class="form-group justify-content-end mr-5">
        <b-col lg="2">
          <b-button
            :title="changePassword_Validatechanges"
            variant="primary"
            @click="changePassword">
            <i class="fa-light fa-floppy-disk"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import backButton from "@/components/common/backButton.vue"
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    // 'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      login: '',
      originalPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      connectToGoogle: false,
      returnUrl: '/profile/'
    }
  },
  created () {
    this.changePassword_title = this.$i18n.t('common.chg_pwd')
    this.changePassword_Validatechanges = this.$i18n.t('common.valid_chgs')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.login = this.$engine.user.get().identifier
  },
  mounted () {
    //console.log(this.$engine.user.connectBy)
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.connectToGoogle = true
    } else {
      this.connectToGoogle = false
    }
  },
  methods: {
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: this.$t('common.security.password_modified'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        if (error.response.data.error === 'oldPassword not valid') {
          that.$f7.modal({
          title: that.$t('profilesPage.password_old_not_valid'),
          text: error.response.data.errorDescription,
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
        } else {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            let errParsed = error.response.data.error.replace(/\s+/g, '')
            if (('errors._specific.title.' + errParsed) !== that.$t('errors._specific.title.' + errParsed)) {
              errMsgTitle = that.$t('errors._specific.title.' + errParsed)
              errMsgDesc = that.$t('errors._specific.description.' + errParsed)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        }
      })
    },
    changePassword () {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (that.originalPassword === '' && this.$engine.user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert(that.$i18n.t('profilesPage.password_original_missing'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.new_pwd_mssng'), that.$i18n.t('common.error_title'))
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.cnfrm_pwd'), that.$i18n.t('common.error_title'))
      } else if (!regexPassword.test(that.newPassword)) {
        that.$f7.alert(that.$i18n.t('profilesPage.password_wrong_format'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert(that.$i18n.t('common.security.passwords_not_matching'), that.$i18n.t('common.error_title'))
      } else if (that.originalPassword === that.newPassword) {
        that.$f7.alert(that.$i18n.t('common.security.password_same'), that.$i18n.t('common.error_title'))
      } else {
        var connectBy = 'lpc'
        if (this.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBy = 'vgo'
          // On se conecte via Google
          this.$gAuth.signIn()
          .then(() => {
            that.changePasswordAPI(connectBy)
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        } else {
          this.changePasswordAPI(connectBy)
        }
      }
    }
  }
}
</script>
<style scoped>
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
</style>
